import React from 'react';
import PropTypes from 'prop-types';

const Defs = props => (
   <defs>
      {/*<style type="text/css">*/}

      {/*</style>*/}

      {/*<filter id="blurMe">*/}
      {/*   <feGaussianBlur stdDeviation="2"/>*/}
      {/*</filter>*/}

      <linearGradient
         x1="0%"
         y1="47.6739715%"
         x2="100%"
         y2="51.7232396%"
         id="linearGradient-1"
      >
         <stop stopColor="#007AFF" offset="0%"/>
         <stop stopColor="#FF3B30" offset="10.7309978%"/>
         <stop stopColor="#FF3B30" offset="82.7323905%"/>
         <stop stopColor="#007AFF" offset="100%"/>
      </linearGradient>
      <linearGradient x1="14.2786281%" y1="0%" x2="85.7213719%" y2="87.0425314%"
                      id="linearGradient-2">
         <stop stopColor="#007AFF" offset="0%"/>
         <stop stopColor="#FF3B30" offset="10.7309978%"/>
         <stop stopColor="#FF3B30" offset="82.7323905%"/>
         <stop stopColor="#007AFF" offset="100%"/>
      </linearGradient>
      <linearGradient x1="72.7383522%" y1="54.3732811%" x2="89.302723%" y2="57.2822069%"
                      id="linearGradient-3">
         <stop stopColor="#FF3B30" offset="0%"/>
         <stop stopColor="#007AFF" offset="100%"/>
      </linearGradient>

     <polygon id="path-1" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>
     <polygon id="path-3" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>
     <polygon id="path-5" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>
     <polygon id="path-7" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>
     <polygon id="path-9" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>
     <polygon id="path-11" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>
     <polygon id="path-13" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>
     <polygon id="path-15" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>
     <polygon id="path-17" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>
     <polygon id="path-19" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>
     <polygon id="path-21" points="0 8.42105263 9.55 8.42105263 9.55 0.0278947368 0 0.0278947368"></polygon>

     <path
       d="M31.9419597,12 L47.9961996,10.8972914 C66.0711887,9.65578469 84.1438982,13.348112 100.283477,21.5797927 L256,101 L256,101"
       id="path-4"/>

      <linearGradient x1="100.772608%" y1="23.0507252%" x2="1.16900925%" y2="77.073523%"
                      id="linearGradient-5">

         <stop stopColor="#000000" offset="0%"/>
         <stop stopColor="#000000" offset="37.3347255%"/>
         <stop stopColor="#FF3B30" offset="43.4166851%"/>
         <stop stopColor="#FF3B30" offset="66.0939252%"/>
         <stop stopColor="#007AFF" offset="69.9714914%"/>
         <stop stopColor="#007AFF" offset="100%"/>
      </linearGradient>

      <filter id="sofGlow" height="310%" width="310%" x="-75%" y="-75%">
         <feMorphology operator="dilate" radius="5" in="SourceAlpha" result="thicken"/>
         <feGaussianBlur in="thicken" stdDeviation="3" result="blurred"/>
         <feFlood floodColor="rgb(255,255,255)" result="glowColor"/>
         <feComposite in="glowColor" in2="blurred" operator="in" result="softGlow_colored"/>

         <feMerge>
            <feMergeNode in="softGlow_colored"/>
            <feMergeNode in="SourceGraphic"/>
         </feMerge>
      </filter>

      <filter id="sofGlowNone" height="310%" width="310%" x="-75%" y="-75%">
         <feMorphology operator="dilate" radius="0" in="SourceAlpha" result="thicken"/>
         <feGaussianBlur in="thicken" stdDeviation="0" result="blurred"/>
         <feFlood floodColor="rgb(255,255,255)" result="glowColor"/>
         <feComposite in="glowColor" in2="blurred" operator="in" result="softGlow_colored"/>

         <feMerge>
            <feMergeNode in="softGlow_colored"/>
            <feMergeNode in="SourceGraphic"/>
         </feMerge>
      </filter>
   </defs>
);

Defs.propTypes = {};

export default Defs;
